import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom"; 
import { toastr } from "react-redux-toastr";
import firebase from './../../firebase';

const fetchDocument = async (collection, documentId) => {
    try {
      const docRef = firebase.firestore().collection(collection).doc(documentId);
      const doc = await docRef.get();
      if (doc.exists) {
        return doc.data();  // Retourne les données du document
      } else {
        throw new Error('Document not found');
      }
    } catch (error) {
      console.error("Error getting document:", error);
      throw error;
    }
  };

  const updateDocument = async (collection, documentId, data) => {
    try {
      const docRef = firebase.firestore().collection(collection).doc(documentId);
      await docRef.update(data);  // Met à jour les données du document
      return true;
    } catch (error) {
      console.error("Error updating document:", error);
      throw error;
    }
  };

const ConnectHandler = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // Récupérer les paramètres de la requête
  const id = queryParams.get("id");
  const fhspid = queryParams.get("fhspid");

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => { 
    const handleAuthorization = async () => {
      try {
        if (!id || !fhspid) {
          throw new Error("Paramètres requis manquants dans l'URL.");
        }

        // Récupérer les données associées à `id`
        const userData = await fetchDocument("properties", id);
        if (!userData) {
          throw new Error("Propriété non trouvé.");
        }

        // Mettre à jour les informations de l'utilisateur avec `fhspid`
        await updateDocument("properties", id, { fhsId: fhspid, _update_At : new Date()});

        toastr.success(
          "Connexion réussie",
          `La propriété ${userData.nameHouse} est maintenant connecté à la propriété FHS.`
        );
        setLoading(false);
      } catch (err) {
        setError(err.message);
        toastr.error("Erreur", err.message);
        setLoading(false);
      }
    };

    handleAuthorization();
  }, [id, fhspid]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
        Chargement...
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mt-5">
        <div className="alert alert-danger">
          <h4>Erreur</h4>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  const redirectToProperty = () => {
    if (id) {
      toastr.success("Redirection"); 
      window.location.href = `/villa/edit/${id}`;
    } else {
      toastr.error("Propriété inconnue");
    }
  };


  return (
    <div className="container mt-5">
      <div className="alert alert-success">
        <h4>Connexion réussie</h4>
        <p>Les données ont été mises à jour avec succès.</p> 
        <button
                  onClick={redirectToProperty}
                  className="btn btn-primary mt-4" 
                >
                  Voir la propriété
                </button>
      </div>
    </div>
  );
};

export default ConnectHandler;